import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { setCookies } from '../hooks/useCookies';
import { SERVER_URL } from './apiConstants';

const headers = {
  'Content-Type': 'application/json; charset=utf-8',
  'Access-Control-Allow-Origin': '*',
};
const login = 'login';
export const logIn = createAsyncThunk('api/logIn', async (data, { rejectWithValue }) => {
  const body = { email: data.email, password: data.Password };
  try {
    const response = await axios.post(`${SERVER_URL}/${login}`, body, { headers });
    if (response.status === 200) {
      setCookies('Token', response.data.data.tokens.access.token);
      setCookies('refreshToken', response.data.data.tokens.refresh.token);
      setCookies('USERID', response.data.data.user.id);
      setCookies('PROFILE', response.data.data.user.image);
      setCookies('USERNAME', response.data.data.user.name);
      setCookies('USERROLE', response.data.data.user.role.name);
      setCookies(
        'USERPERMISSION',
        response.data.data.user.role?.permissions ||
          response.data.data.user.menuPermissions ||
          []
      );
      setCookies('THEME', 'false');
      return response.data;
    }
    return rejectWithValue({
      message: response.data?.message || 'Login failed',
      code: response.status,
    });
  } catch (err) {
    const message =
      err.response?.data?.message ||
      err.message ||
      'Unable to reach the server. Check your connection or try again later.';
    return rejectWithValue({ message, code: err.response?.status || 0 });
  }
});

const loginSlice = createSlice({
  name: 'api',
  initialState: {
    loading: false,
    loginData: {},
    error: '',
  },
  extraReducers: {
    [logIn.pending]: (state) => {
      /* eslint-disable no-param-reassign */
      state.loading = true;
    },
    [logIn.fulfilled]: (state, action) => {
      state.loading = false;
      state.loginData = action.payload;
    },
    [logIn.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export default loginSlice.reducer;
